import { Injectable } from '@angular/core';
import * as pako from 'pako';

@Injectable({
  providedIn: 'root',
})
export class DecompressionService {
  constructor() {}

  decompressMessage(compressedData: string): string {
    try {
      // Decode base64-encoded compressed string to bytes
      const compressedByteString = atob(compressedData);
      const compressedBytes = new Uint8Array(compressedByteString.length);
      for (let i = 0; i < compressedByteString.length; i++) {
        compressedBytes[i] = compressedByteString.charCodeAt(i);
      }

      // Decompress compressed bytes to utf-8 bytes
      const decompressedBytes = pako.inflate(compressedBytes);

      // Decode utf-8 bytes to string
      const decompressedData = new TextDecoder('utf-8').decode(decompressedBytes);

      return decompressedData;
    } catch (e) {
      if (e instanceof DOMException && e.name === 'InvalidCharacterError') {
        console.error('Error base64 decoding:', e);
      } else {
        console.error('Error decompressing:', e);
      }
      return '';
    }
  }
}
